let parameters = {
    chartDataSource: {
        label: 'Chart Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: false
    },
    groupData: {
        label: 'Group',
        class: 'xs12 sm12',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        items: [],
        item: {},
        wait: false
    },
    valueData: {
        label: 'Value',
        class: 'xs12 sm6',
        type: 'select',
        source: 'parameters.chartDataSource.item.headers',
        itemText: 'text',
        itemValue: 'value',
        item: {},
        items: [],
        wait: false
    },
    transformValueData: null,
    label: {
        label: 'Label',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    target: {
        label: 'Target',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    title: {
        label: 'Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    subtitle: {
        label: 'Sub Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: undefined,
        display: true,
        wait: false
    },
    legendPositionData : null,
    showLegendSource: null,
    themeDataSource: {
        label: 'Theme',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemText: 'name',
        itemValue: 'id',
        items: [],
        wait: false
    },
    colorGradient: {
        label: 'ThemeColor',
        class: 'xs12 sm12 d-flex',
        type: 'theme-color',
        source: 'parameters.themeDataSource.item.data',
        itemText: 'name',
        itemValue: 'id',
        item: {},
        items: [],
        wait: false,
        value: null
    }
};

export default parameters;
